"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ButtonConstants_1 = require("../Button/ButtonConstants");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const noop_1 = __importDefault(require("lodash/noop"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
const Icon_1 = __importDefault(require("../Icon/Icon"));
const AddSmall_1 = __importDefault(require("../Icon/Icons/components/AddSmall"));
const IconButton_helpers_1 = require("./services/IconButton-helpers");
const test_utils_1 = require("../../utils/test-utils");
const Button_1 = __importDefault(require("../Button/Button"));
const IconButton_module_scss_1 = __importDefault(require("./IconButton.module.scss"));
const IconButton = (0, react_1.forwardRef)(({ className, wrapperClassName, id, icon, size, tooltipContent, ariaLabel, hideTooltip, kind, active, disabled, disabledReason, onClick, color, dataTestId, insetFocus }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const buttonAriaLabel = (0, react_1.useMemo)(() => {
        if (ariaLabel)
            return ariaLabel;
        if (typeof tooltipContent === "string")
            return tooltipContent;
        return undefined;
    }, [ariaLabel, tooltipContent]);
    const iconSize = (0, react_1.useMemo)(() => {
        switch (size) {
            case Button_1.default.sizes.XXS:
            case Button_1.default.sizes.XS:
                return 16;
            case Button_1.default.sizes.SMALL:
            case Button_1.default.sizes.MEDIUM:
            case Button_1.default.sizes.LARGE:
                return ButtonConstants_1.BUTTON_ICON_SIZE;
            default:
                return 24;
        }
    }, [size]);
    const overrideStyle = (0, react_1.useMemo)(() => {
        let style = {
            justifyContent: "center",
            alignItems: "center",
            padding: 0
        };
        if (active && kind !== IconButton.kinds.PRIMARY) {
            style.background = "var(--primary-selected-color)";
        }
        if (active && kind === IconButton.kinds.SECONDARY) {
            style.borderColor = "var(--primary-color)";
        }
        if (size) {
            style = Object.assign(Object.assign({}, style), (0, IconButton_helpers_1.getWidthHeight)(size));
        }
        return style;
    }, [active, kind, size]);
    const calculatedTooltipContent = (0, react_1.useMemo)(() => {
        if (hideTooltip)
            return null;
        if (disabled && disabledReason)
            return disabledReason;
        if (tooltipContent)
            return tooltipContent;
        return ariaLabel;
    }, [hideTooltip, disabled, disabledReason, tooltipContent, ariaLabel]);
    const IconButtonWrapper = wrapperClassName ? "div" : react_1.Fragment;
    const iconButtonWrapperProps = (0, react_1.useMemo)(() => {
        return wrapperClassName ? { className: (0, classnames_1.default)(wrapperClassName, IconButton_module_scss_1.default.wrapper) } : {};
    }, [wrapperClassName]);
    return ((0, jsx_runtime_1.jsx)(IconButtonWrapper, Object.assign({}, iconButtonWrapperProps, { children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ content: calculatedTooltipContent, referenceWrapperClassName: IconButton_module_scss_1.default.referenceWrapper }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: onClick, disabled: disabled, color: color, kind: kind, ariaLabel: buttonAriaLabel, ref: mergedRef, id: id, dataTestId: dataTestId || (0, test_utils_1.getTestId)(test_utils_1.ELEMENT_TYPES.ICON_BUTTON, id), noSidePadding: true, active: active, className: className, style: overrideStyle, insetFocus: insetFocus }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: icon, iconType: Icon_1.default.type.SVG, iconSize: iconSize, ignoreFocusStyle: true, className: "icon-button-padding", clickable: false }) })) })) })));
});
Object.assign(IconButton, {
    sizes: Button_1.default.sizes,
    kinds: Button_1.default.kinds,
    colors: Button_1.default.colors
});
IconButton.defaultProps = {
    className: undefined,
    wrapperClassName: undefined,
    onClick: noop_1.default,
    id: undefined,
    icon: AddSmall_1.default,
    ariaLabel: undefined,
    size: IconButton === null || IconButton === void 0 ? void 0 : IconButton.sizes.MEDIUM,
    hideTooltip: false,
    tooltipContent: undefined,
    kind: IconButton.kinds.TERTIARY,
    disabled: false,
    disabledReason: undefined,
    color: undefined,
    dataTestId: undefined,
    insetFocus: false
};
exports.default = IconButton;
